export enum PageTypes {
  BUILD_YOUR_OWN = 'build_your_own',
  DECISION_TOOL = 'decision_tool',
  MULTIPLE_CHOICE = 'multiple_choice',
}
